// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { Database } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                <Database className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">US Real Estate Data</span>
            </div>
            <p className="text-gray-400 mb-4">
              Your source for comprehensive U.S. real estate datasets.
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="#features" className="hover:text-white transition-colors" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#features').scrollIntoView({ behavior: 'smooth' });
              }}>Features</Link></li>
              <li><Link to="#pricing" className="hover:text-white transition-colors" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#pricing').scrollIntoView({ behavior: 'smooth' });
              }}>Pricing</Link></li>
              <li><Link to="#how-it-works" className="hover:text-white transition-colors" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#how-it-works').scrollIntoView({ behavior: 'smooth' });
              }}>How It Works</Link></li>

            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">About</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Careers</a></li>
              <li><Link to="#contact" className="hover:text-white transition-colors" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
              }}>Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Terms</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© 2025 US Real Estate Data. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;